
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component<CartSuiteTab>({})
export default class CartSuiteTab extends Vue {
	@Getter('getUserEventSuite', { namespace: 'suites' }) private userEventSuite!: UserEvent;
	@Getter('getRestaurant', { namespace: 'restaurant' }) private restaurant!: Restaurant;

	/**
	 * Get content and css classes for tab display
	 */
	private get tab(): { classList: string[]; content: string } {
		if (this.userEventSuite && this.userEventSuite.tab_limit){
			const balance: number = this.userEventSuite.tab_balance ? Number(this.userEventSuite.tab_balance) : 0;
			const percentUsed: number = (balance / this.userEventSuite.tab_limit) * 100;

			let classList: string[] = ['tab-limit-content', 'label-md'];

			switch(true) {
				case percentUsed >= 95:
					classList = [...classList, 'danger'];
					break;
				case percentUsed >= 80:
					classList = [...classList, 'warning'];
					break;
				default:
					classList = [...classList, 'success'];
			}

			return {
				classList,
				content: this.$t('checkout.cart.viewer.suites.tab', { balance: this.$n(balance, 'currency'), limit: this.$n(this.userEventSuite.tab_limit, 'currency') })
			};
		}
		else {
			return {
				classList: ['tab-limit-content', 'label-md', 'info'],
				content: this.$t('checkout.cart.viewer.suites.tab_not_active')
			};
		}
	}

	private navigateToSuiteSettings(): void {
		this.$router.push({
			path: `${this.restaurant.slug}/suite-settings`,
			query: {
				eventDayOrdering: this.$route.query.eventDayOrdering,
				eventSuite:this.$route.query.eventSuite,
				suiteOperator: this.$route.query.suiteOperator,
				menuList: this.$route.query.menuList,
				...this.$route.query
			},
			hash: this.$route.hash
		}).catch(() => {});
	}
}
